/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import PropTypes from 'prop-types';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';

const DateRangePicker = ({ dates, handleDateRangePicker, onClose }) => {
  const [selectedDateRange, setSelectedDateRange] = useState(
    dates?.length
      ? dates.map((d) => moment(d).toDate())
      : [new Date(), new Date()]
  );

  useEffect(() => {
    if (dates?.length) {
      setSelectedDateRange(dates.map((d) => moment(d).toDate()))
    }
  }, [dates]);

  const onSelectedRange = (_dates) => {
    setSelectedDateRange(_dates);
    handleDateRangePicker(
      moment(_dates[0]).format('YYYY-MM-DD'),
      moment(_dates[1]).format('YYYY-MM-DD'),
    );
    onClose();
  };

  return (
    <Calendar
      selectRange
      value={selectedDateRange}
      onChange={onSelectedRange}
    />
  );
};

DateRangePicker.propTypes = {
  handleDateRangePicker: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  dates: PropTypes.array,
};

DateRangePicker.defaultProps = {
  dates: [],
};

export default DateRangePicker;
